import { canExport, startExport } from 'cadenza/api-client/table-export-api';
import { AbstractExportAction } from 'cadenza/actions/table/abstract-export-action';

/**
 * @typedef {AbstractExportAction~Options} AbstractTableExportAction~Options
 * @property {SearchUrlProvider} [searchUrlProvider] - Provides URL as base url for api calls
 */

/**
 * Provides URL as base url for api calls
 *
 * @function SearchUrlProvider
 * @return {URL}
 */

export class AbstractTableExportAction extends AbstractExportAction {

  /** @type {string} */
  _mediaType;
  /** @type {SearchUrlProvider} */
  _searchUrlProvider;

  /**
   * @param {string} mediaType - Media Type of the target file to use for api calls
   * @param {AbstractTableExportAction~Options} options
   */
  constructor (mediaType, options = {}) {
    super(options);
    this._mediaType = mediaType;
    this._searchUrlProvider = options.searchUrlProvider || (() => location.search);
  }

  canExport () {
    return canExport(this._searchUrlProvider(), this._mediaType);
  }

  startExport () {
    return startExport(this._searchUrlProvider(), this._mediaType);
  }

}
